import type { ActionIconProps } from '@mantine/core';
import { rem } from '@mantine/core';

import classes from './toolbar-button.module.css';

export const TOOLBAR_HEIGHT = rem(78);
export const TOOLBAR_HEIGHT_FIXED_HEADER = rem(78 - 44);

export const toolbarCommonProps: Partial<ActionIconProps> = {
	className: classes.button,
	variant: 'subtle',
};
